import styles from './GuestsSelector.module.css';

export const GuestsGroup = ({ onFooterClick, children, footer }) => {
  return (
    <div className={styles.guest_dropdown_list}>
      {children}
      <div className={styles.border} />
      <div className={styles.footer} onClick={onFooterClick}>
        {footer}
      </div>
    </div>
  );
};
